// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timeline-container {
  position: absolute;
  display: flex;
  flex-direction: column;
  /* gap: 10px; */
  bottom: 1px;
  width: 100%;
  /* height: 25%; */
  /* background-color: rgba(51, 51, 51, 0.7); */
  /* opacity: 0.; */
  /* border: solid; */
  /* height: 1.7em; */
  background: linear-gradient(to bottom, rgba(116, 117, 119, 0.8) 0%, rgba(58, 68, 82, 0.8) 11%, rgba(46, 50, 56, 0.8) 46%, rgba(53, 53, 53, 0.8) 81%, rgba(53, 53, 53, 0.8) 100%);
}

.cesium-viewer-timelineContainer {
  position: unset !important;
  border: none !important;
  height: 3.5vh;
}
.cesium-viewer-timelineContainer .cesium-timeline-main {
  border: none !important;
}
.cesium-viewer-timelineContainer .cesium-timeline-main .cesium-timeline-bar {
  background: unset;
  height: 3.5vh !important;
}

.timeline-bar-container {
  display: flex;
  align-items: center;
  /* width: 100%; */
  margin: 3px 10px;
  /* Low opacity background */
  color: white;
  /* White text color */
  height: 3.5vh;
}

.timeline-bar-clock {
  margin-left: 5px;
}

.timeline-bar-controls {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-around;
  font-size: 1.5em;
  z-index: 1;
}
.timeline-bar-controls button {
  background-color: rgba(69, 76, 88, 0.8);
  border: none;
  color: rgb(85, 85, 85);
  padding: 5px 10px;
  cursor: pointer;
  border-radius: 4px;
  margin: 5px;
}
.timeline-bar-controls button:hover {
  background-color: rgb(85, 85, 85);
  /* Button hover effect with opacity */
}
.timeline-bar-controls .multiplier {
  font-size: 1.2em;
}
.timeline-bar-controls .play-pause {
  margin-left: 20px;
}
.timeline-bar-controls .current-time {
  align-items: center;
  font-size: 1.2em;
}

@media (max-width: 768px) {
  .timeline-bar-controls {
    font-size: 1.2em;
  }
  .timeline-bar-controls button {
    padding: 5px 7px;
    margin: 3px;
  }
  .timeline-bar-controls .play-pause {
    margin-left: 5px;
  }
}
@media (max-width: 480px) {
  .timeline-bar-controls {
    font-size: 1em;
  }
  .timeline-bar-controls button {
    padding: 5px 5px;
    margin: 1px;
  }
}`, "",{"version":3,"sources":["webpack://./src/satmon/modules/timeline/timeLineBar.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,iBAAA;EACA,6CAAA;EAEA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gLAAA;AAAJ;;AAGA;EACI,0BAAA;EACA,uBAAA;EACA,aAAA;AAAJ;AAEI;EACI,uBAAA;AAAR;AAEQ;EACI,iBAAA;EACA,wBAAA;AAAZ;;AAMA;EACI,aAAA;EAEA,mBAAA;EACA,iBAAA;EACA,gBAAA;EAEA,2BAAA;EACA,YAAA;EACA,qBAAA;EACA,aAAA;AALJ;;AAQA;EACI,gBAAA;AALJ;;AAQA;EACI,aAAA;EACA,OAAA;EACA,mBAAA;EACA,6BAAA;EACA,gBAAA;EACA,UAAA;AALJ;AAOI;EACI,uCAAA;EACA,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;AALR;AAQI;EACI,iCAAA;EACA,qCAAA;AANR;AASI;EACI,gBAAA;AAPR;AAUI;EACI,iBAAA;AARR;AAWI;EACI,mBAAA;EACA,gBAAA;AATR;;AAaA;EACI;IACI,gBAAA;EAVN;EAYM;IACI,gBAAA;IACA,WAAA;EAVV;EAaM;IACI,gBAAA;EAXV;AACF;AAeA;EACI;IACI,cAAA;EAbN;EAeM;IACI,gBAAA;IACA,WAAA;EAbV;AACF","sourcesContent":[".timeline-container {\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    /* gap: 10px; */\n    bottom: 1px;\n    width: 100%;\n    /* height: 25%; */\n    /* background-color: rgba(51, 51, 51, 0.7); */\n\n    /* opacity: 0.; */\n    /* border: solid; */\n    /* height: 1.7em; */\n    background: linear-gradient(to bottom, rgba(116, 117, 119, 0.8) 0%, rgba(58, 68, 82, 0.8) 11%, rgba(46, 50, 56, 0.8) 46%, rgba(53, 53, 53, 0.8) 81%, rgba(53, 53, 53, 0.8) 100%);\n}\n\n.cesium-viewer-timelineContainer {\n    position: unset !important;\n    border: none !important;\n    height: 3.5vh;\n\n    .cesium-timeline-main {\n        border: none !important;\n\n        .cesium-timeline-bar {\n            background: unset;\n            height: 3.5vh !important;\n\n        }\n    }\n}\n\n.timeline-bar-container {\n    display: flex;\n    // justify-content: space-between;\n    align-items: center;\n    /* width: 100%; */\n    margin: 3px 10px;\n    // background-color: rgba(51, 51, 51, 0.7);\n    /* Low opacity background */\n    color: white;\n    /* White text color */\n    height: 3.5vh;\n}\n\n.timeline-bar-clock {\n    margin-left: 5px;\n}\n\n.timeline-bar-controls {\n    display: flex;\n    flex: 1;\n    align-items: center;\n    justify-content: space-around;\n    font-size: 1.5em;\n    z-index: 1;\n\n    button {\n        background-color: rgba(69, 76, 88, 0.8);\n        border: none;\n        color: rgba(85, 85, 85, 1);\n        padding: 5px 10px;\n        cursor: pointer;\n        border-radius: 4px;\n        margin: 5px;\n    }\n\n    button:hover {\n        background-color: rgba(85, 85, 85, 1);\n        /* Button hover effect with opacity */\n    }\n\n    .multiplier {\n        font-size: 1.2em;\n    }\n\n    .play-pause {\n        margin-left: 20px;\n    }\n\n    .current-time {\n        align-items: center;\n        font-size: 1.2em;\n    }\n}\n\n@media (max-width: 768px) {\n    .timeline-bar-controls {\n        font-size: 1.2em;\n\n        button {\n            padding: 5px 7px;\n            margin: 3px;\n        }\n\n        .play-pause {\n            margin-left: 5px;\n        }\n    }\n}\n\n@media (max-width: 480px) {\n    .timeline-bar-controls {\n        font-size: 1em;\n\n        button {\n            padding: 5px 5px;\n            margin: 1px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
